import { render, staticRenderFns } from "./AssetIcon.vue?vue&type=template&id=3b694d33&scoped=true&"
import script from "./AssetIcon.vue?vue&type=script&lang=js&"
export * from "./AssetIcon.vue?vue&type=script&lang=js&"
import style0 from "./AssetIcon.vue?vue&type=style&index=0&id=3b694d33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b694d33",
  null
  
)

export default component.exports